import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import styled from 'styled-components'

export const LiveTxt = styled.span<{ $theme: ThemeMode }>`
  color: ${(props) => (props.$theme === ThemeMode.DARK ? '#cc170e' : 'var(--red)')};
`

LiveTxt.displayName = 'LiveTxt'

export const LiveIconBox = styled.picture<{ invert?: boolean }>`
  width: 2rem;
  height: 2rem;
  background-color: ${({ invert = false }) => (invert ? '#270400' : '#FFF0F0')};
  border-radius: 50%;

  > svg {
    width: 1rem;
    height: 1rem;

    > path {
      color: var(--red);
    }
  }
`

LiveIconBox.displayName = 'LiveIconBox'
